import { peopleString } from './occupancyToStr';

export const searchString = (rooms) => `${peopleString(rooms)}`;
